import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import { Toaster } from './components/ui/toaster';
import { LanguageProvider } from './i18n/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import SplashScreen from './components/SplashScreen';

function App() {
  useEffect(() => {
    document.title = 'GiCleanly — Clean Spaces, Deep Clear';
  }, []);

  return (
    <div className="App">
      <ThemeProvider>
        <LanguageProvider>
          <SplashScreen />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
